import { existsOperator } from "./exists";
export const conditionOperators = [existsOperator];
export function findConditionOperator({ operatorId, }) {
    return conditionOperators.find((operator) => operator.id === operatorId);
}
